import axios from 'axios';
import { getAuth } from 'firebase/auth'; // Firebase Auth import

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LOG_API_BASE_URL = `${API_BASE_URL}/public/log/frontend`;

class logService {

      async sendFrontendLog(message, level = 'info') {
          return axios.post(`${LOG_API_BASE_URL}`, message, {
          });
      }
  
}

export default new logService();  

